import { Collapse, Switch, Tooltip } from 'antd';
import Form from '../forms/forms'
// import { useDispatch, useSelector } from 'react-redux';
// import { checkProfileCard } from '../../Redux/Actions/CardAction';
const { Panel } = Collapse;

const PersonalInfo = ({ edit }) => {
  // const {  checkPfCard } = useSelector((state) => state.cardReducer);
  // const dispatch = useDispatch();
  const onChange = (key) => {
    console.log(key);
  };
  const onChangeToggle = (checked) => {
    console.log(`switch to ${checked}`);
    // dispatch(checkProfileCard(checked));
  };
  return (
    // <div className={personalDetails?.name && personalDetails?.companyDesignation && personalDetails?.companyName && personalDetails?.mobile && personalDetails?.email || !validationCheck  ? '' : `border rounded-lg border-red-500 `}>
    <div>

      <Collapse defaultActiveKey={['0']} onChange={onChange} className='flex justify-between'>
        <Panel header="Basic Information" key="1" className='w-full'>
          <Form edit={edit}/>
        </Panel>
        {/* {edit ? */}
          <p className='w-20 bg-white  border-b rounded-r-xl '>
            <p className='bg-slate-50 h-[47px] border-b rounded-r-md  py-3'>
              {/* <Tooltip placement="top" title={`${checkPfCard ? 'hide profile card' : 'show profile card'}`}>
                <Switch defaultChecked={checkPfCard} className='bg-gray-400' onChange={onChangeToggle} />
              </Tooltip> */}
            </p>
          </p> 
          {/* : ''
        } */}

      </Collapse>
    </div>
  );
};
export default PersonalInfo;